
























































































































































































import {Component, Watch, Mixins, Vue, Prop} from 'vue-property-decorator'
import {$, IResource, PageCollection, ObjectCollection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySacPublic from '@/components/filters/FilterDeliverySacPublic.vue'
import DeliverySacPublicRequest from '@/model/request/DeliverySacPublicRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import SacResponse from '@/model/response/SacResponse'
import FilterToggle from '@/components/FilterToggle.vue'
import itTrackingSlider from '@/components/itrack/ItTrackingSlider.vue'
import * as Helper from '@/helpers'
import {MapConfig} from '@/config/map.config'
import moment from 'moment'
import DeliverySacAttemptResponse from '@/model/resource/DeliverySacAttemptResponse'

enum State {
    INIT = 1,
    SELECTED = 2,
    LISTED = 3,
}

const metaInfo = () => ({
    title: $.t('view.reports.deliverySacPublic.title'),
})

@Component({
    metaInfo,
    components: {FilterDeliverySacPublic, FilterToggle, itTrackingSlider},
})
export default class ReportsDeliverySacPublicResultView extends Mixins(MixinFilter) {
    @Prop({type: String}) type?: string
    @Prop({type: String, default: null}) token?: string | null

    AppConfig = AppConfig
    State = State
    Helper = Helper
    MapConfig = MapConfig

    state = State.INIT

    // Selected item
    model: Carga | null = null
    emptyListTitle: String | null = null

    filter = new DeliverySacPublicRequest()
    filterSac = new DeliverySacPublicRequest()

    collection = new CargaCollection(this.filter, '/user/carga/sac/guest', 10)
    collectionSac = new PageCollection(SacResponse, this.filterSac, null, null)

    showFilter = true
    populateOnMount = false

    queriesToHide: string[] = ['login', 'senha']

    async populate() {
        try {
            await this.query()
        } catch (e) {
            if (e.status === 400) {
                this.emptyListTitle = e.body.message
            }
        }
    }

    @Watch('collection.items', {deep: true})
    async listEvent(items: Carga[]) {
        if (!this.filter.isCleared && items.length === 1 && !this.filter.cpfCnpj) {
            await this.select(items[0])
        }

        if (items.length === 0) {
            this.emptyListTitle = $.t('view.reports.deliverySacPublic.fragmentDinamicEmptyListNoElements')
        }
    }

    @Watch('state')
    async stateEvent(state: State) {
        if (state === State.LISTED) {
            this.model = null
            this.collectionSac.items = []
        } else if (state === State.SELECTED) {
            await Helper.sleep(1000)

            if (this.model) {
                await this.collectionSac.search()
            }
        } else if (state === State.INIT) {
            this.model = null

            this.filter.clean()
            this.filterSac.clean()

            this.collection.items = []
            this.collectionSac.items = []

            this.showFilter = false
            await this.$nextTick()
            this.showFilter = true
        }
    }

    get eyeIcon() {
        return `<img src="./img/itrack/view-circle-contrast.svg" alt="view-circle">`
    }

    get isSacDinamic() {
        return !this.isDpk && !this.isHavanna && !this.isSantillana
    }

    get lastSac() {
        const items = this.collectionSac.items
        return items[items.length - 1]
    }

    list() {
        this.state = State.LISTED
        if (this.filter.dataCriacao !== null || this.filter.startDate !== null || this.filter.endDate !== null)  {
            const filterDate = this.filter.dataCriacao || this.filter.startDate || this.filter.endDate
            const comp = moment().subtract(3, 'months')
            const date = moment(filterDate)
            if (comp.isAfter(date)) {
                this.emptyListTitle = $.t('view.reports.deliverySacPublic.fragmentDinamicEmptyList')
                    + ' ' +  comp.format('DD/MM/YYYY')
            } else {
              this.emptyListTitle = $.t('app.noResultFound')
            }
        } else {
            this.emptyListTitle = $.t('app.noResultFound')
        }
    }

    async select(model: Carga) {
        this.state = State.SELECTED
        this.model = model
        this.filterSac.danfe = model.danfe
        this.filterSac.nroFiscal = model.nroNotaFiscal
        this.filterSac.idEmbarcador = model.embarcador.responsavel.$id
        this.filterSac.idCarga = model.idCargaPk

        await this.getRastreamentoDistancia()
    }

    async getRastreamentoDistancia() {
      if (this.model && !this.model.distanciaParaDestinoEmMetros && !this.model.duracaoParaDestinoEmSegundos) {
          const {data} = await this.filterSac.getRastreamentoDistancia(this.model.idCargaPk)

          if (data && data.distanciaParaDestinoEmMetros && data.duracaoParaDestinoEmSegundos) {
            this.model.distanciaParaDestinoEmMetros = data.distanciaParaDestinoEmMetros
            this.model.duracaoParaDestinoEmSegundos = data.duracaoParaDestinoEmSegundos
          }
      }

      $.await.done('getRastreamentoDistancia')
    }

    init() {
        this.state = State.INIT
    }

    async backToList() {
      this.filterSac.idCarga = null
      this.filter.idCarga = null
      await this.filtrateSac()
    }

    async filtrateSac() {
        if (this.filter.isCleared) {
            this.init()
        } else {
            this.list()
        }
        await Helper.sleep(1000)
        await this.filtrate()
    }

    async clean() {
        this.filter = new DeliverySacPublicRequest()
        this.filterSac = new DeliverySacPublicRequest()
        await this.filtrateSac()
    }

    created() {
        if (this.filter.nroFiscal) {
          const nroFiscalList = this.filter.nroFiscal.split(',')
          const nroFiscalResource = nroFiscalList.map( (item) => ({ $tag: item, $id: item }))
          this.filter.allDocs = new ObjectCollection(nroFiscalResource)
        }

        if (this.type) {
            this.collection.endpoint = `/user/${this.type}/sac`
        }

        if (this.isDpk) {
            this.collection.endpoint = '/user/dpk/sac'
        } else if (this.isHavanna) {
            this.collection.endpoint = '/user/havanna/sac'
        } else if (this.isSantillana) {
            this.collection.endpoint = '/user/santillana/sac'
        }
    }

    async mounted() {
        if (this.filter.isCleared) {
          this.$router.push('/sac')
        }

        this.collectionSac.endpoint = '/user/carga/tentativa/guest'

        if (!this.$route.query.token && !this.type && this.isSacDinamic) {
            this.$modal.open('prompt')
        } else {
            try {
                await this.filtrateSac()
            } catch {
                this.$router.replace('/sac')
            }
        }

        if (this.filter.cpfCnpj) {
            this.filter.login = `${this.filter.cpfCnpj}`
        }
    }

    async submitPrompt() {
        this.$modal.close('prompt')

        try {
            await this.filtrateSac()
        } catch {
            Helper.backHistory()
        }
    }

    get isDpk() {
        return this.$route.path.includes('dpk')
    }

    get isHavanna() {
        return this.$route.path.includes('havanna')
    }

    get isSantillana() {
        return this.$route.path.includes('santillana')
    }

    get showDownloadXlxsButton() {
      return !this.isDpk && !this.isHavanna && !this.isSantillana
    }

    async downloadData() {
      if (this.state === State.SELECTED) {
        this.filter.idCarga = this.filterSac.idCarga
      } else {
        this.filter.idCarga = null
      }
      await $.await.run(() => Helper.downloadXlsx(
        $.t('view.get.deliverySacAttemptResponse.title'),
        '/user/carga/sac/reports/guest',
        this.filter,
        DeliverySacAttemptResponse,
        'DeliverySacAttemptResponse',
      ), 'download')
    }

    onFilter() {
      this.filtrateSac()
      this.state = State.LISTED
    }

    getCircleSlaColor(item: Carga) {
      return item.slaCircleClass
    }
}
